<template>
	<v-toolbar flat color="primary" height="30px" style="z-index: 103;">
		<v-toolbar-items>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="onDisplayChange">{{btnNameDisplayChange}}</v-btn>
		</v-toolbar-items>
		<v-spacer />
		<v-toolbar-items>
			<h3 style="color: white; margin-top:.25em;">写真一覧</h3>
		</v-toolbar-items>
		<v-spacer />
		<v-toolbar-items>
			<v-btn flat large color="white" @click="onClose">
				<v-icon>clear</v-icon>
			</v-btn>
		</v-toolbar-items>
	</v-toolbar>
</template>

<script>
import {DISPLAY_LIST_TYPE} from '../../data/Const';

export default {
	name: 'GBPhotoAlbumHeader',
	components: {
	},
	props: [ 'backURL', 'display_list_type' ],
	data(){
		return {
		}
	},
	methods: {
		onDisplayChange: function() {
			let uri = '';
			if (this.backURL) {
				uri = this.backURL;
			} else {
				if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
				} else {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
				}
			}
			this.$router.push(uri);
		},
		onClose: function() {
			this.$router.push('/' + this.$route.params.contractor_id);
		},
	},
	computed: {
		btnNameDisplayChange: function() {
			let name = '';
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				name = 'メンバー表示';
			} else if (this.display_list_type == DISPLAY_LIST_TYPE.MEMBER) {
				name = '案件表示';
			} else {
				name = '戻る';
			}
			return name;
		},
	},
}
</script>
